import { render, staticRenderFns } from "./popup-rule.vue?vue&type=template&id=f6250068&scoped=true&"
import script from "./popup-rule.vue?vue&type=script&lang=js&"
export * from "./popup-rule.vue?vue&type=script&lang=js&"
import style0 from "./popup-rule.vue?vue&type=style&index=0&id=f6250068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6250068",
  null
  
)

export default component.exports